import { AUTO_PALETTE } from "../constants/palettes";
import { mix } from "../theme/colorEngine";

// Pick a category color that no existing category already uses. First hands out
// the 12 distinct palette hues; once those run out it tone-shifts a palette base
// (lighter/darker, growing each cycle) until it finds a shade nobody's using — so
// every card keeps a different color instead of repeating one.
export function pickCategoryColor(usedColors, count = 0) {
  const used = new Set(usedColors);
  const fresh = AUTO_PALETTE.find(c => !used.has(c));
  if (fresh) return fresh;
  const base = AUTO_PALETTE[count % AUTO_PALETTE.length];
  for (let cycle = 1; cycle <= 4; cycle++) {
    const t = 0.14 * cycle;
    for (const variant of [mix(base, "#ffffff", t), mix(base, "#000000", t)]) {
      if (!used.has(variant)) return variant;
    }
  }
  return base;
}
